module.exports = __webpack_public_path__ + "static/media/271631.832f0ba2.svg";